import { createBrowserRouter } from 'react-router-dom'
import Main from '../layout/Main'
import ErrorPage from '../components/ErrorPage'
import Home from '../components/Home'
import Login from '../components/Login'
import Register from '../components/Register'
import PrivateRoute from './PrivateRoute'
import Profile from '../components/Profile'
import Wallet from '../components/Wallet'

const router = createBrowserRouter([
  {
    path: '/',
    element: <Main />,
    errorElement: <ErrorPage />,
    children: [
      { path: '/', element: <Home /> },
      { path: 'home', element: <Home /> },
      { path: 'login', element: <Login /> },
      { path: 'register', element: <Register /> },
      {
        path: 'profile',
        element: (
          <PrivateRoute>
            <Profile />
          </PrivateRoute>
        ),
      },
      {
        path: 'wallet',
        element: (
          <PrivateRoute>
            <Wallet />
          </PrivateRoute>
        ),
      },
    ],
  },
])

export default router
